class ActionFailException extends Error {
	/** @constructor
	 * @type {(message: string, code: null | string | number, stack: string[], originalError: Error)}
	 */
	constructor(message, code = null, stack = [], originalError = {}) {
		super("ActionFailException");
		this.name = this.constructor.name;
		this.code = code;
		this.message = message;
		/** @TODO: rename `stack` field to `details` */
		this.stack = stack;
		this.originalError = originalError;
		this.localeMessage = this.stack[0] || this.message;
	}
}

export default ActionFailException;
